export const melodies = {
  gameOver: [
    { note: 'C4', duration: '8n' },
    { note: 'G3', duration: '8n' },
    { note: 'E3', duration: '8n' },
    { note: 'C3', duration: '4n' },
  ],
  highScore: [
    { note: 'C4', duration: '16n' },
    { note: 'E4', duration: '16n' },
    { note: 'G4', duration: '16n' },
    { note: 'C5', duration: '16n' },
    { note: 'G4', duration: '8n' },
    { note: 'C5', duration: '4n' },
  ],
};
